<template>
    <div :class="`stockDayChange ${getCardClass}`">{{ dayChangeValue }}</div>
</template>

<script>
import StockHtmlHelper from './StockHtmlHelper';

export default {
    props: ['stock'],
    data() {
        return {
            stockHtmlHelper: null
        }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    computed: {
        dayChange() {
            return this.stock.statistics.normalizedWithPreferredCurrency.dayChange ? this.stock.statistics.normalizedWithPreferredCurrency.dayChange : 0;
        },
        getCardClass() {
            return this.dayChange < 0 ? "down" : this.dayChange > 0 ? 'up' : '';
        },
        dayChangeValue() {
            const symbol = this.dayChange > 0 ? '+' : ''
            return `${symbol}${this.stockHtmlHelper.formatChange(this.dayChange, this.stock.stockDateTimeSnapshot.price)}`
        }
    }
}
</script>

<style lang="scss" scoped>
.stockDayChange {
    font-weight: bold;
    &.up{
        color: var(--v-greenUp-base);
    }
    &.down{
        color: var(--v-redDown-base);
    }
}
</style>